import {
  ISpectrumBankAccountApproveRejectRequest,
  ISpectrumBankAccountApproveRejectResponse,
  ISpectrumBankAccountGlobalResult,
  ISpectrumBankAccountListResponse,
  ISpectrumBankAccountRegisterRequest,
  ISpectrumBankAccountSearchByCustomerRequest,
  ISpectrumBankAccountSearchRequest,
} from '../common/interfaces'
import { apiUrl } from '../config/api'

const trimAccount = <T extends { codCliente: string; numIdentidad?: string }>(account: T): T => ({
  ...account,
  codCliente: account.codCliente?.trim(),
  ...(account.numIdentidad !== undefined ? { numIdentidad: account.numIdentidad.trim() } : {}),
})

export const SpectrumBankAccountService = () => {
  const searchByCustomer = (req: ISpectrumBankAccountSearchByCustomerRequest) =>
    apiUrl
      .post('backoffice/bank-account/spectrum/search-by-customer', {
        ...req,
        numIdentidad: req.numIdentidad.trim(),
      })
      .then((res) => res.data as ISpectrumBankAccountListResponse<ISpectrumBankAccountGlobalResult>)
      .then((res) => ({ ...res, data: res.data.map(trimAccount) }))

  const search = (req: ISpectrumBankAccountSearchRequest) =>
    apiUrl
      .post('backoffice/bank-account/spectrum/search', req)
      .then((res) => res.data as ISpectrumBankAccountListResponse<ISpectrumBankAccountGlobalResult>)
      .then((res) => ({ ...res, data: res.data.map(trimAccount) }))

  const register = (req: ISpectrumBankAccountRegisterRequest) =>
    apiUrl
      .post('backoffice/bank-account/spectrum/register', {
        ...req,
        numIdentidad: req.numIdentidad.trim(),
      })
      .then((res) => res.data as { data: boolean })

  const approveReject = (req: ISpectrumBankAccountApproveRejectRequest) =>
    apiUrl
      .post('backoffice/bank-account/spectrum/approve-reject', {
        ...req,
        numIdentidad: req.numIdentidad.trim(),
      })
      .then((res) => res.data as ISpectrumBankAccountApproveRejectResponse)
      .then((res) => ({ ...res, numIdentidad: res.numIdentidad.trim() }))

  const exportAccounts = () =>
    apiUrl
      .post('backoffice/bank-account/spectrum/export', undefined, { responseType: 'blob' })
      .then((res) => res.data as Blob)

  return {
    searchByCustomer,
    search,
    register,
    approveReject,
    exportAccounts,
  }
}
